export const availableLanguages = ['de', 'en', 'fr', 'nl', 'it', 'es'];
